import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import isEqual from 'lodash-es/isEqual';

import intlShape from '@/shared/utils/intlShape';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
import { DeleteIcon } from '@/shared/components/Icons';
import OkCancelModal from '../../../../shared/components/OkCancelModal';

import api from '../../../../shared/api';
import config from '../../../../config';

const messages = defineMessages({
  SelectTagsToAdd: 'Select tags to add',
});

class EditDocumentTypesTagDialog extends PureComponent {
  constructor(props) {
    super(props);

    const { documentTags } = props;
    this.state = {
      documentTags: [...documentTags],
      selectedTag: null,
    };
  }

  addTag = item => {
    if (!item) return;
    const { allTags } = this.props;
    const tag = allTags.find(x => x.id === item.key);
    if (!tag) return;
    this.setState(
      ({ documentTags }) => ({
        documentTags: [...documentTags, tag],
        selectedTag: item,
      }),
      () => {
        this.setState({ selectedTag: null });
      },
    );
  };
  removeTag = tagId => {
    this.setState(({ documentTags }) => ({
      documentTags: documentTags.filter(x => x.id !== tagId),
    }));
  };

  save = () => {
    const { documentTags } = this.state;
    const { documentTypeId, documentTags: oldTags, onClose } = this.props;
    if (isEqual(documentTags, oldTags)) {
      onClose(null); // Nothing changed
      return;
    }

    return api.base
      .put(`${config.appUrls.documents}/api/TagType/Tags`, {
        documentType: documentTypeId,
        tags: documentTags.map(x => x.id),
      })
      .then(() => {
        onClose(documentTags);
      });
  };

  render() {
    const { documentTags, selectedTag } = this.state;
    const { onClose, intl, documentTypeName, allTags } = this.props;
    const availableTags = (documentTags && documentTags.length > 0
      ? allTags.filter(x => documentTags.findIndex(y => y.id === x.id) === -1)
      : allTags
    ).map(x => ({ ...x, key: x.id, label: x.name }));

    return (
      <OkCancelModal
        show
        title={documentTypeName}
        onClose={() => onClose(null)}
        onSave={() => this.save()}
      >
        {availableTags.length > 0 && (
          <div className="margin10B">
            <AutoComplete
              items={availableTags}
              placeholder={intl.formatMessage(messages.SelectTagsToAdd)}
              onChange={item => this.addTag(item)}
              mode="edit"
              autoFocus
              value={selectedTag}
            />
          </div>
        )}
        {documentTags.map(x => (
          <div key={x.id} className="pad5">
            <span className="margin5R">{x.name}</span>
            <DeleteIcon onClick={() => this.removeTag(x.id)} />
          </div>
        ))}
      </OkCancelModal>
    );
  }
}

const tagShape = PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.name });

EditDocumentTypesTagDialog.propTypes = {
  documentTypeId: PropTypes.number.isRequired,
  documentTypeName: PropTypes.string.isRequired,
  documentTags: PropTypes.arrayOf(tagShape).isRequired,
  allTags: PropTypes.arrayOf(tagShape).isRequired,
  onClose: PropTypes.func.isRequired, // (newTypes)=>{}
  intl: intlShape.isRequired,
};

export default injectIntl(EditDocumentTypesTagDialog);
